module.exports = __webpack_public_path__ + "img/iPhone6plus-5.5-Portrait.7364aa4d.png";